import React, { memo } from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/system'

import Text from '../shared/text/Text'

const GradientBox = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1),
  textAlign: 'center',
  background: `linear-gradient(135deg, ${theme.palette.primary.mid}, ${theme.palette.primary.main})`,
  boxShadow: theme.shadows[2],
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: theme.zIndex.appBar + 1
}))

const NotificationBar = ({ message, notifyRef }) => {
  return (
    <GradientBox ref={notifyRef}>
      <Text
        variant='body2'
        component='div'
        label={message}
        sx={{ color: 'common.black', fontWeight: 700 }}
      />
    </GradientBox>
  )
}

export default memo(NotificationBar)
